import { mapValues } from '@exodus/basic-utils';
import type NumberUnit from '@exodus/currency';
import type { Selector } from 'reselect';
import { createSelector } from 'reselect';

import selectors from '../../selectors.js';

type State = object;

const byAssetUsdSelector = createSelector(
  selectors.fiatBalances.byAsset as Selector<
    unknown,
    Record<string, NumberUnit>
  >,
  selectors.balances.byAsset as Selector<unknown, Record<string, NumberUnit>>,
  ((state) => state) as Selector<unknown, State>,
  (fiatBalances, balances, state) => {
    return mapValues(fiatBalances, (fiatBalance, assetName) => {
      if (fiatBalance.defaultUnit.unitName === 'USD') {
        return fiatBalance;
      }

      const convert =
        selectors.fiatBalances.createAssetConversionUsd(assetName)(state);

      return convert(balances[assetName]);
    });
  },
);

export default byAssetUsdSelector;
